import styled from 'styled-components';

export const PillWrapperStyled = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${({ $compact }) => ($compact ? '2px' : '8px')};
  background: ${({ $compact, theme }) =>
    $compact ? 'transparent' : (theme?.colors?.light ?? '#F7F7F7')};
  border-radius: ${({ $compact }) => ($compact ? '0' : '6px')};
  padding: ${({ $compact }) => ($compact ? '0' : '6px 12px')};
  /* In compact (table-cell) mode the wrapper is exactly as wide as its two
     icon buttons so switching states never changes the cell's rendered size. */
  width: ${({ $compact }) => ($compact ? '52px' : 'auto')};
  flex-shrink: 0;
`;

export const FileNameTextStyled = styled.span`
  flex: 1;
  font-size: 13px;
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
`;
